<script setup>
import { loc } from '@/__core__/localization/localization'
import { inject } from 'vue';

const langId = inject('langId', '')
const status = inject('status')

const props = defineProps({
  label: {
    type: String,
    default: () => 'Previous Meetings'
  },
  homeWins: {
    type: [Number, String],
    default: () => '-'
  },
  awayWins: {
    type: [Number, String],
    default: () => '-'
  },
  draws: {
    type: [Number, String],
    default: () => '-'
  }
})
</script>

<template>
  <div class="szw-flex szw-flex-col szw-bg-latest-background-color-secondary szw-w-full szw-rounded-2 szw-gap-2 szw-p-2">
    <div class="szw-row__center szw-items-center">
      <span v-if="status === 'loading'" class="szw-w-[160px] szw-bg-section-static szw-h-[14px] szw-animate-pulse szw-rounded-1"></span>
      <span v-if="status === 'success'" class="szw-font-medium szw-text-[12px] szw-uppercase szw-leading-[14px] szw-tracking-[4%]">{{ props.label }}</span>
    </div>

    <div class="szw-row__between szw-w-full szw-text-latest-text-icon-secondary szw-h-[24px]">
      <div class="szw-uppercase szw-font-medium szw-bg-latest-team-home szw-text-[12px] szw-leading-[14px] szw-tracking-[4%] szw-w-full szw-rounded-l-[4px] szw-h-full szw-flex szw-justify-center szw-items-center">
        {{ props.homeWins }} {{ (props.homeWins || props.homeWins === 0) && props.homeWins !== '-' ? loc('standings_win_short', langId) : '' }}
      </div>
      <div class="szw-uppercase szw-font-medium szw-bg-latest-disable-dark szw-text-[12px] szw-leading-[14px] szw-tracking-[4%] szw-w-2/3 szw-h-full szw-flex szw-justify-center szw-items-center">
        {{ props.draws }} {{ (props.draws || props.draws === 0) && props.draws !== '-' ? loc('standings_draw_short', langId) : ''}}
      </div>
      <div class="szw-uppercase szw-font-medium szw-bg-latest-team-away szw-text-[12px] szw-leading-[14px] szw-tracking-[4%] szw-w-full szw-rounded-r-[4px] szw-h-full szw-flex szw-justify-center szw-items-center">
        {{ props.awayWins }} {{ (props.awayWins ||  props.awayWins === 0) && props.awayWins !== '-' ? loc('standings_win_short', langId) : '' }}
      </div>
    </div>
  </div>
</template>
